import { ReactNode } from 'react';

import * as S from './styled';

interface Props {
  icon: ReactNode;
  title: ReactNode;
  text: ReactNode;
}

/** Diz de que lado do OCPI a aba está: o que a conta envia como CPO ou recebe como eMSP. */
const DirectionBanner = ({ icon, title, text }: Props) => (
  <S.DirectionBanner>
    <span className="icon">{icon}</span>
    <div>
      <div className="title">{title}</div>
      <div className="text">{text}</div>
    </div>
  </S.DirectionBanner>
);

export default DirectionBanner;
